import * as Dialog from "@radix-ui/react-dialog";

import { cn } from "../lib/cn";

export interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  size?: "sm" | "md" | "lg";
  title?: string;
  description?: string;
  children: React.ReactNode;
}

const sizeClasses = {
  sm: "max-w-[400px]",
  md: "max-w-[560px]",
  lg: "max-w-[720px]",
};

export function Modal({
  open,
  onOpenChange,
  size = "md",
  title,
  description,
  children,
}: ModalProps) {
  const resolvedDescription =
    description ?? (title ? `${title} dialog` : "Modal dialog");

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 animate-[fadeIn_0.2s_ease] bg-black/60 backdrop-blur-sm" />
        <Dialog.Content
          className={cn(
            "fixed left-1/2 top-1/2 z-50 w-[90vw] -translate-x-1/2 -translate-y-1/2",
            "octa-md bg-[rgba(16,18,22,0.95)] p-6",
            "[backdrop-filter:var(--glass-blur)] [filter:drop-shadow(0_0_1px_rgba(201,168,76,0.35))_drop-shadow(0_8px_40px_rgba(0,0,0,0.5))]",
            "animate-[fadeUp_0.3s_var(--ease-luxury)]",
            sizeClasses[size],
          )}
        >
          {title && (
            <Dialog.Title className="text-text mb-4 font-serif text-xl">
              {title}
            </Dialog.Title>
          )}
          <Dialog.Description className="sr-only">
            {resolvedDescription}
          </Dialog.Description>
          {children}
          <Dialog.Close
            className="text-text-muted hover:text-text absolute right-4 top-4"
            aria-label="Close"
          >
            &times;
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
